import type {MakeChangeGroupsOrchestrationState} from '../types/group-types'

export function isCompletedChangeGroupState(state: MakeChangeGroupsOrchestrationState) {
  switch (state) {
    case 'CREATED':
    case 'RUNNING':
    case 'STARTED':
    case 'WAITING':
      return false
    case 'ABANDONED':
    case 'FAILED':
    case 'SKIPPED':
    case 'SUCCEEDED':
      return true
    default:
      return true
  }
}

export function isErrorState(state: MakeChangeGroupsOrchestrationState) {
  switch (state) {
    case 'ABANDONED':
    case 'FAILED':
    case 'SKIPPED':
      return true
    case 'CREATED':
    case 'RUNNING':
    case 'STARTED':
    case 'SUCCEEDED':
    case 'WAITING':
      return false
    default:
      return false
  }
}
